export const DEFAULT_SITE_PRIMARY_TITLE = "QIH - Digital Adventures";

export const LIFE_TIME_COOKIE_NAME = "p7d80fUq38d7";
export const USER_COOKIE_NAME = "b757dc61e858";
export const SESSION_COOKIE_NAME = "ec61fcf2b2f0";
export const CLICK_OUT_COOKIE_NAME = "6pO7eE5JBKmg";
export const SKIP_LEAD_FORM_COOKIE_NAME = "3onptVxMt7vw";
export const DEFAULT_SESSION_COOKIE_MINUTES = 180;
export const DEFAULT_USER_COOKIE_MAX_AGE_DAYS = 30;
export const LANDING_PAGE_COMPLETE_COOKIE_NAME = "7X9bTfTk0HsI";
export const OFFER_CLAIM_COOKIE_NAME = "s39sEjeRDOue";

// The skyscraper images have no index (they are not in a list),
// but we can pass in -1 to still be able to uniquely identify a click
// on a skyscraper image in our click-out data
export const AD_UNIT_SKYSCRAPER_INDEX = -1;

export const SEARCH_ENGINES = [
    "https://www.google.com/",
    "https://www.bing.com/",
];
export const NUMBER_OF_GENERIC_VARS = 8;
export const DEFAULT_AUTHENTICATED_STRING = "authenticated";
export const DEFAULT_UNAUTHENTICATED_STRING = "unauthenticated";
export const FORM_DATA_COOKIE_NAME = "formData";
export const LANDING_PAGE_TEMPLATE_CACHE_KEY_COOKIE_NAME = "grbFTo6u34JI";
export const LANDING_PAGE_URL_COOKIE_NAME = "dU84cb2VvZLn";
export const DEFAULT_DATALAYER_NAME = "dataLayer";
export const COMPLETED_COMPETITION_DRAW_ID_COOKIE = '7b6848f896ec9411a8141f1348473ff8';
